// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	let booking_special = document.querySelector( ".sp_18037 .js-update-dates" );
	if( booking_special ){
		let d = new Date();
		let currentDate = new Date();
		currentDate.setDate( d.getDate() + 7 );
		let month = currentDate.getMonth() + 1;

		let departure = new Date();
		departure.setDate( currentDate.getDate() + 4 ) ;
		let month_departure = departure.getMonth() + 1;
		booking_special.href = booking_special.href + "&arrivalDate=" + currentDate.getFullYear() + "-" + ( month < 10 ? "0" + month : month ) + "-" + currentDate.getDate() 
							+ "&departureDate=" + departure.getFullYear() + "-" + ( month_departure < 10 ? "0" + month_departure : month_departure ) + "-" + departure.getDate() 
							+ "&groupCode=p4"

		console.log( booking_special.href );
	}

	$(document).ready(function () {
		$('.header__burger').click(function() {
		    $('.header').toggleClass('nav-open');
			if($('.header').hasClass('widget-open')) {
				$('.header').removeClass('widget-open');
				$('.booking-block').removeClass('open');
				$('.header__book').text('Book Now');
			}
			var text = $('.header__burger-label').text();
			$('.header__burger-label').text(
				text == "Menu" ? "Close" : "Menu");
		});

		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});


	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

}